const EMAIL_ADDRESS_PATTERN =
  /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)+$/
const DOMAIN_PATTERN =
  /^(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?$/

function parseValues(
  value: string,
  label: string,
  pattern: RegExp,
  maximumLength: number,
  validate: boolean,
): string[] {
  const entries = value
    .split("\n")
    .map((entry) => entry.trim().toLowerCase())
    .filter(Boolean)
  if (
    validate &&
    entries.some(
      (entry) =>
        entry.length > maximumLength ||
        entry.includes("*") ||
        !pattern.test(entry),
    )
  ) {
    throw new Error(
      `${label} must contain complete, valid entries without wildcards.`,
    )
  }
  return [...new Set(entries)].sort()
}

export function parseEmailRecipientAllowlist(
  addresses: string,
  domains: string,
  validate = true,
) {
  return {
    approvedEmailRecipients: parseValues(
      addresses,
      "Approved email addresses",
      EMAIL_ADDRESS_PATTERN,
      320,
      validate,
    ),
    approvedEmailDomains: parseValues(
      domains,
      "Approved domains",
      DOMAIN_PATTERN,
      253,
      validate,
    ),
  }
}
